import React, { createContext, useContext } from "react";

const LanguageContext = createContext<string>("uz");

export const useLanguage = () => useContext(LanguageContext);

interface LanguageProviderProps {
  children: React.ReactNode;
  lang: string;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children, lang }) => {
  return (
    <LanguageContext.Provider value={lang}>
      {children}
    </LanguageContext.Provider>
  );
};
